/**
 * @file Badge 状态徽标
 * @description 紧凑状态色标签；无关闭。
 *
 * @whenToUse 表格状态列、标题旁标记。
 * @whenNotToUse 可关闭筛选标签（用 Tag）。
 */

import type { HTMLAttributes } from 'react'
import { cn } from '@/lib/cn.ts'

export type BadgeVariant =
  | 'default'
  | 'success'
  | 'warning'
  | 'danger'
  | 'accent'

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & {
  variant?: BadgeVariant
}

const variantClass: Record<BadgeVariant, string> = {
  default: 'bg-accent/25 text-foreground',
  success: 'bg-success/20 text-success',
  warning: 'bg-warning/20 text-warning',
  danger: 'bg-danger/20 text-danger',
  /** 实心主色，强调一眼可辨 */
  accent: 'bg-primary text-primary-foreground',
}

export function Badge({
  variant = 'default',
  className,
  children,
  ...rest
}: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium',
        variantClass[variant],
        className,
      )}
      {...rest}
    >
      {children}
    </span>
  )
}
